import { cardsItems } from '@/mocks/homeData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=A%20dramatic%20corporate%20office%20building%20silhouette%20at%20night%20with%20one%20lit%20window%2C%20warm%20crimson%20accent%20lighting%2C%20moody%20editorial%20photography%20style%2C%20investigative%20atmosphere%2C%20no%20people%20visible&width=600&height=400&seq=card-1-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20film%20director%20chair%20on%20an%20empty%20movie%20set%20with%20dramatic%20spotlight%2C%20warm%20crimson%20and%20dark%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20no%20people%20visible&width=600&height=400&seq=card-2-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=An%20empty%20music%20festival%20stage%20with%20abandoned%20equipment%2C%20dramatic%20moody%20lighting%2C%20warm%20crimson%20and%20dark%20palette%2C%20editorial%20photography%20style%2C%20atmospheric%2C%20no%20people&width=600&height=400&seq=card-3-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20dark%20restaurant%20kitchen%20with%20dramatic%20shadows%2C%20warm%20crimson%20accent%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20investigative%20mood%2C%20no%20people%20visible&width=600&height=400&seq=card-4-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20grand%20charity%20gala%20venue%20empty%20and%20dark%20with%20dramatic%20shadows%2C%20warm%20crimson%20highlights%2C%20editorial%20photography%2C%20mysterious%20atmosphere%2C%20no%20people%20visible&width=600&height=400&seq=card-5-2026&orientation=landscape',
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-article-line"></i>
            原创内容
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">深度爆料</h2>
          <p className="text-foreground-600 text-sm">编辑团队深度挖掘，呈现事件完整面貌</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsItems.slice(0, 5).map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-secondary-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer flex flex-col"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={cardImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    if (t.parentElement) t.parentElement.style.backgroundColor = 'oklch(0.87 0.052 25)';
                  }}
                />
                <span className="absolute top-3 left-3 text-xs px-2 py-0.5 rounded-full bg-background-50/80 backdrop-blur-sm text-primary-700 font-medium">
                  {item.category}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4 flex-1">{item.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400 pt-3 border-t border-secondary-100">
                  <span>{item.author}</span>
                  <span>{item.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}